import * as types from './types';

function setPageContent({ pageId, data }) {
    return {
        payload: {
            data,
            pageId,
        },
        type: types.SET_PAGE_DATA,
    };
}

export {
    setPageContent,
};
